import { render, staticRenderFns } from "./gainsLossesItem.vue?vue&type=template&id=0431f897"
import script from "./gainsLossesItem.vue?vue&type=script&lang=js"
export * from "./gainsLossesItem.vue?vue&type=script&lang=js"
import style0 from "./gainsLossesItem.vue?vue&type=style&index=0&id=0431f897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports